import React from "react";
import "./Sales.css";
import salesImg from "../Images/sales.png";
import { Link } from 'react-router-dom';

const Sales = () => {


  return (
    <main className="sh-landing-container">
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {/* Sales Section */}
      <section className="sh-section reverse" >
        <div className="sh-img-left-sale">
          <img src={salesImg} alt="Sales" />
        </div>
        <div className="sh-text-right-sale">
          <h2> GROWTH PARTNERS </h2>
           <p className="tag">Leverage your network, bring opportunities, and grow with us</p>
          <p className="tag1">
            College TPOs,<br /> Sales & Placement Pros
            Referral Partners & <span className="hh">Lead Gen Experts</span>
          </p>

          <p className="tag2">
            Got a strong network in education or hiring? Let’s monetize it together. As a growth partner, you’ll help us onboard colleges, startups, or hiring partners to our platform and earn on every successful conversion.
          </p>

          {/* <a
            href="https://forms.gle/B9ZHm3azzM9suzsN9"
            target="_blank"
            rel="noopener noreferrer"
          > */}
          <Link to="/RedirectToForm"> <button className="sh-secondary-btn">Connect Now</button> </Link>
          {/* </a> */}
        </div>
      </section>

    </main>
  );
};

export default Sales;